import getExtensionFromFileName from './getExtensionFromFileName';
var imageFileExtensions = [
    '.bmp',
    '.gif',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.jfif',
    '.dib',
    '.png',
    '.psd',
    '.tiff',
    '.tif',
];
export default function isImageFile(fileName) {
    var extension = getExtensionFromFileName(fileName);
    if (extension) {
        return imageFileExtensions.indexOf(extension.toLowerCase()) >= 0;
    }
    return false;
}
//# sourceMappingURL=isImageFile.js.map